import { combineReducers } from 'redux';
import executeReducer from './executeReducer';
import staffReducer from './staffReducer';
import templateReducer from './templateReducer';
import rankReducer from '../actions/rankActions';
import noticeReducer from '../actions/noticeActions';
import memberReducer from '../actions/memberActions';
import competeCompanyReducer from '../actions/competeCompanyActions';
import investigationReducer from '../actions/investigationActions';
import departmentReducer from '../actions/departmentActions';
import personalReducer from '../actions/PersonalActions';
import homeReducer from '../actions/homeActions';
import homePageState from '../components/homePage/store';
import hospitalState from '../components/hospital/store';
import manHourState from '../components/manHour/store';
import inProjectReducer from '../actions/inProjectActions';
import quotationState from '../components/quotation/store';
import menuState from '../actions/menuActions';
import researchCenter from '../actions/researchCenter';
import clinicalEvaluationReducer from '../actions/clinicalEvaluationActions';

const reducers = combineReducers({
    investigationState: investigationReducer,
    executeState: executeReducer,
    staffInfo: staffReducer,
    templateState: templateReducer,
    rankState: rankReducer,
    noticeState: noticeReducer,
    memberState: memberReducer,
    competeCompanyState: competeCompanyReducer,
    departmentState: departmentReducer,
    personalState: personalReducer,
    homeState: homeReducer,
    inProjectState: inProjectReducer,
    homePageState,
    hospitalState,
    quotationState,
    manHourState,
    menuState,
    researchCenter,
    clinicalEvaluationState: clinicalEvaluationReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js